import { render } from "./AssignmentsTable.vue?vue&type=template&id=5a84b5ce&scoped=true"
import script from "./AssignmentsTable.vue?vue&type=script&lang=js"
export * from "./AssignmentsTable.vue?vue&type=script&lang=js"

import "./AssignmentsTable.vue?vue&type=style&index=0&id=5a84b5ce&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a84b5ce"]])

export default __exports__